import React from "react";
import styled from "styled-components";

const Link = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  padding: 5px 10px 0px;
  text-transform: uppercase;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 4px;
  font-size: ${(props) => props?.fontSize || "16px"};
  transition: 0.2s;
  color: var(--water-color);
  overflow: hidden;
  -webkit-box-reflect: below 0px linear-gradient(#0000, #0002);

  &:hover {
    color: #255784;
    background: var(--water-color);
    box-shadow: 0 0 10px var(--water-color), 0 0 40px var(--water-color),
      0 0 80px var(--water-color);
    transition-delay: 1s;
  }

  svg {
    // padding-right: 5px;
    // font-size: 36px;
    color: var(--water-color);
  }

  span:nth-child(1) {
    top: 0;
    left: -100%;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, transparent, #ffffff);
  }

  &:hover span:nth-child(1) {
    left: 100%;
    transition: 1s;
  }

  span:nth-child(3) {
    bottom: 0;
    right: -100%;
    width: 100%;
    height: 2px;
    background: linear-gradient(270deg, transparent, #ffffff);
  }

  &:hover span:nth-child(3) {
    right: 100%;
    transition: 1s;
    transition-delay: 0.5s;
  }

  span:nth-child(2) {
    top: -100%;
    right: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(180deg, transparent, #ffffff);
  }

  &:hover span:nth-child(2) {
    top: 100%;
    transition: 1s;
    transition-delay: 0.25s;
  }

  span:nth-child(4) {
    bottom: -100%;
    left: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(360deg, transparent, #ffffff);
  }

  &:hover span:nth-child(4) {
    bottom: 100%;
    transition: 1s;
    transition-delay: 0.75s;
  }
`;
const Span = styled.span`
  position: absolute;
  display: block;
`;

function ButtonLink({ text, icon, Id, link, onClick, fontSize }) {
  return (
    <Link
      href={`${Id ? `#${Id}` : `${link}`}`}
      target={link && `_blank`}
      onClick={onClick}
      fontSize={fontSize}
    >
      <Span></Span>
      <Span></Span>
      <Span></Span>
      <Span></Span>
      {icon}
      {text}
    </Link>
  );
}

export default ButtonLink;
